/**
 * ReportsHarvestInspectionsTotalCard
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Header, Segment } from 'semantic-ui-react';

// Selectors
import { makeSelectFieldTotal } from './selectors';

interface Props {
    title: string;
    value: string;
    postfix?: string;
}

export class ReportsHarvestInspectionsTotalCard extends React.PureComponent<Props> {
    render() {
        const { title, value, postfix } = this.props;
        return (
            <Segment
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: 10
                }}
            >
                <Header as="h2" textAlign="center">
                    <Header.Content>
                        {value}
                        {postfix}
                        <Header.Subheader color="grey">
                            {title}
                        </Header.Subheader>
                    </Header.Content>
                </Header>
            </Segment>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    value: makeSelectFieldTotal()
});

export default connect(mapStateToProps)(ReportsHarvestInspectionsTotalCard);
